import { atom } from "jotai";
import { atomFamily } from "jotai/utils";
import { calculateTotals, getOrderCurrency } from "../lib/financials.lib";
import type { FinancialSummary, Order } from "../types";
import { draftReturnAtomFamily } from "./draft-return.atom";

const EMPTY_SUMMARY: FinancialSummary = {
  refundTotal: 0,
  exchangeTotal: 0,
  exchangeCreditTotal: 0,
  discountTotal: 0,
  rebuyTotal: 0,
  amountDue: 0,
  currency: "EUR",
  taxMultiplier: 1,
};

export const financialSummaryAtomFamily = atomFamily(
  (params: { orderId: string; order: Order | null }) =>
    atom<FinancialSummary>((get) => {
      const draft = get(draftReturnAtomFamily(params.orderId));
      const lineItems = draft?.lineItems ?? [];
      const rebuyItems = draft?.rebuyItems ?? [];
      if (!params.order || lineItems.length === 0) {
        return { ...EMPTY_SUMMARY, currency: getOrderCurrency(params.order) };
      }
      return calculateTotals(lineItems, params.order, rebuyItems);
    }),
  (a, b) => a.orderId === b.orderId && a.order === b.order,
);
